import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import QRCode from 'react-qr-code';

const ImprimirEtiquetaCama = forwardRef((props, ref) => {

    const [valvula, setValvula] = useState({})

    useEffect(() => {}, [valvula])

    useImperativeHandle(ref, () => ({
        setInfoEt(v) {
            setValvula(v);
        },
    }));

    return (
        <div className="content-center">
            {valvula.hasOwnProperty('camas') && <button
                className="text-white text-sm bg-orange-800 rounded hover:bg-orange-600 focus:outline-none px-2 py-1 mb-2">
                Imprimir
            </button>}
            { valvula.hasOwnProperty('camas') &&
                <table>
                    <tbody>
                    {valvula.camas.map((c, i) => {
                        return (
                            <tr key={i}>
                                <td className="text-center border px-4 py-2">
                                    <QRCode value={valvula.planId + "-" + valvula.valvulasId + "-" + c.indice}
                                            size={130}/>
                                </td>
                                <td className="border px-4 py-2" valign="top">
                                    {c.nombreTipoFlor} <br/>
                                    Válvula: { valvula.valvula.codigo } <br/>
                                    No. Cama: { c.indice }
                                </td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            }
        </div>
    )
});

export default ImprimirEtiquetaCama;
